import React, { useState, useEffect } from 'react';
import Yellowbox from './Yellowbox/Yellobox.jsx';
import Greenbox from './Greenbox/Greenbox.jsx';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { get_apps, get_login,user_profile } from '../../api/api.js';
import { useMediaQuery } from 'react-responsive';
import { TbMoodSad } from "react-icons/tb";
import Tile from "./Tile.jsx"

function Temporaryblankbox(props) {
  const [userApps, setUserApps] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const [usrAppsNotify, setUserAppsNotify] = useState('');
  const isMobile = useMediaQuery({ query: '(max-width: 723px)' });
  const isTab = useMediaQuery({ query: '(min-width: 724px) and (max-width: 1330px)' });
  

  // const apptilesCount = userApps.length;
  

 /*
  const getuserapps = async () => {
    const response = await user_profile();
    console.log('Response from new API ',response)
   if (response.status === 200 && response.apps.length > 0) {
      const appnames = response.data.map((item, i) => ({
        key: i,
        label: item.appname,
        value: item.applogo,
        url: item.appurl,
      }));
      setUserApps(appnames);
      setItemCount(response.data.length); // Set item count
    }else if(response.data.length===0){
      setUserAppsNotify(response.message)
    }
  };*/
 const getuserapps = async () => {
    try {
        const response = await user_profile();
        console.log("Response", response)
                     

        


        if (response.status === 200 && response.data.apps.length > 0) {
            const appnames = response.data.apps.map((item, i) => ({
                key: i,
                label: item.appname,
                value: item.applogo,  
                url: item.appurl,
            }));

            
            
            setUserApps(appnames);
	          
            setItemCount(response.apps.length); // Set item count
        } else if (response.apps.length === 0) {
            setUserAppsNotify(response.message);
        }
    } catch (error) {
        console.error('Error fetching user apps:', error);
        setUserAppsNotify("Failed to fetch user apps.");
    }
    console.log('Users Apps ',userApps)
};

  const calculateRowcount = (params) => {


    console.log("Screensize",isTab)

    var res = 0;

    if (isTab==true){    
    res = Math.floor(params / 2 + (params % 2));
    return res;}

    else{
    res = Math.floor(params / 4 + (params % 4));
    return res;}


  }

  const returnTiles = (app, idx, lastcheck) => {
    return (                
                  idx % 2 === 0 ? (
                <Greenbox 
                
                  keyno={idx}
                  imageSrc={`data:image/png;base64,${app.value}`}
                  applink={app.url}
                  applength={userApps.length}
                  lastcheck = {lastcheck}
                  
                  
                />
              ) : (
                <Yellowbox
                  keyno={idx}
                  imageSrc={`data:image/png;base64,${app.value}`}
                  applink={app.url}
                  applength={userApps.length}
                  lastcheck = {lastcheck}
                  
                  
                />
              )


                  



                  
                )




  }

  const returnrowlinesmobile = () => {
    var l = 0;
    var r = 1;
    let rowitems = [];
    let rowcount = [];
    let total = userApps.length;
    var pvalue = total;
    let co = 0;
    
    
    
    

    for (let i = 0; i < pvalue; i++) {
      // if (total % 4 == 1 && Math.floor(total / 4) == 1) {
      
        
        rowitems.push(
          ...userApps
            .slice(l, r)
            .map((tile,idx) => returnTiles(tile,l+idx,l+idx))
        );
        // co = r - l;
        co = rowitems.length;
        console.log("leno", rowitems.length);
        l = r;
        r = l + 1;
        

        rowcount.push(<div className="row">{rowitems}</div>);

        rowitems = [];

        total = total - co;
        
      
    }

    return rowcount;
  }

 
  const returnrowlines = (lastitemsetchecker,maxiteminonerow) => {
    var l = 0;
    var r = maxiteminonerow;
    
    let rowitems = [];
    let rowcount = [];
    let total = userApps.length;
    var pval = calculateRowcount(total);
    let co = 0;
    

    for (let i = 0; i < pval; i++) {
      
      if (total==lastitemsetchecker) {
        r = r - 1;
        
        rowitems.push(
          ...userApps
            .slice(l, r)
            .map((tile,idx) => returnTiles(tile,l+idx,(r-1)))
        );

        co = rowitems.length;
        
        l = r;
        r = userApps.length;

        rowcount.push(<div className="row">{rowitems}</div>);
        rowitems = [];

        total = total - co;
      } else {
        
        rowitems.push(
          ...userApps
            .slice(l, r)
            .map((tile,idx) => returnTiles(tile,l+idx,(r-1)))
        );
        // co = r - l;
        co = rowitems.length;
        
        l = r;
        r = l + maxiteminonerow;
        

        rowcount.push(<div className="row">{rowitems}</div>);

        rowitems = [];

        total = total - co;
        // console.log("newtotal", total);
      }
    }

    return rowcount;
  }


  

  useEffect(() => {
    getuserapps();
    // console.log(userApps);
  }, []);


 


  
  let content;

  if (userApps.length === 0) {
    content = (
      <div className="Mid">
        <div
          className="noapps"
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            height: '50px',
            margin:'auto',
            
            fontSize: '25px',
            fontWeight: '600',
          }}
        >
          <span>
            <TbMoodSad style={{ height: 'auto', width: '400px', margin:'-150px' }} />
          </span>
        </div>
      </div>
    );
  } else if (isTab) {
    content = (
      <div className="Mid">
        {returnrowlines(1,2)}
      </div>
    );
  } else if (isMobile) {
    
    content = (
      
      <div className="Mid">
        
        
        {returnrowlinesmobile()}
      </div>
      
   
    );
  } else {
    content = (
      <div className="Mid">
        {returnrowlines(5,4)}
      </div>
    );
  }


  return(
    <div className='maincontainer'>
      {content}
      </div>
  )

}


export default Temporaryblankbox;
